import { BaseScript } from './BaseScript';
import { matchAll } from '../Utils/unsafe';
import Guid from 'src/Utils/Guid';

export class JavaScript extends BaseScript {
	depsRegex = /hostObject.GetValue\("(.[^"]+)"\)/g;

	/**
	 * Парсим скрипт на наличие элементов
	 */
	override getDependentFields = () => {
		if (!this.Content) {
			return [];
		}
		const matches = matchAll(this.Content, this.depsRegex);
		if (matches) {
			return matches.map((item) => {
				return item[1];
			});
		}
		return [];
	};

	/**
	 * Запустить скрипт в контексте hostObject
	 */
	override runScript = () => {
		if (!this.Content) {
			return null;
		}
		const result = null;
		try {
			window.Guid = Guid;
			window.hostObject = this.hostObject;
			// Некоторые скрипты приезжают с ruby-подобным синтаксисом 'end'
			// Удаляю строки, содержащие только 'end' (как блочный терминатор Ruby), не трогая переменные вида `var end`
			let safeContent = (this.PreparedContent || '').replace(
				/^\s*\bend\b\s*$/gm,
				'',
			);
			// часть старых скриптов приезжает в виде "if hostObject... { ... }" (без скобок вокруг условия), что не валдино для JS
			safeContent = safeContent.replace(
				/if\s+(hostObject[^{]+)\{/gm,
				'if ($1){',
			);
			const evalResult = eval(safeContent);
			return evalResult;
		} catch (e: any) {
			console.warn('JavaScript.runScript error:', e?.message || e, {
				purpose: this.Purpose,
				elementPath: this.contextElement?.FullPath,
			});
		}
		return result;
	};
}
